/* eslint-env jquery */
(function ($) {
  const bodyBlog = $('body').hasClass('single');
  if (bodyBlog) {
    $(document).ready(blogInit);
    $(window).on('resize', blogInit);
  }

  function blogInit() {
    blogHeader();
  }

  function blogHeader() {
    const blogHeaderPadding = Number.parseFloat($('.blog-header').css('padding-top'));
    const blogInfoTop = Number.parseFloat($('.blog-header .blog-info').css('top'));
    const blogInfoHeight = Number.parseFloat($('.blog-header .blog-info').outerHeight() / 2);
    const blogHeaderHeight = blogHeaderPadding + blogInfoTop + blogInfoHeight;
    if (window.matchMedia('(min-width: 992px)').matches) {
      $('.blog-header')
        .css('height', `${blogHeaderHeight}px`)
        .css('margin-bottom', `${blogInfoHeight}px`);
    } else {
      $('.blog-header').css('height', '').css('margin-bottom', '');
    }
  }
})(jQuery);
